/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Free_Tame_Yak_RestInputs */

const en_free_tame_yak_rest = /** @type {(inputs: Free_Tame_Yak_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mobile phone number`)
};

const de_free_tame_yak_rest = /** @type {(inputs: Free_Tame_Yak_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mobiltelefonnummer`)
};

/**
* | output |
* | --- |
* | "Mobile phone number" |
*
* @param {Free_Tame_Yak_RestInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const free_tame_yak_rest = /** @type {((inputs?: Free_Tame_Yak_RestInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Free_Tame_Yak_RestInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_free_tame_yak_rest(inputs)
	return de_free_tame_yak_rest(inputs)
});